import { css, CSSResult } from 'lit'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const cscPdpStickyBar = {
  transitionDuration: css`var(--csc-pdp-sticky-bar-transition-duration, ${csTransition.duration})`,
  transitionTimingFunction: css`var(--csc-pdp-sticky-bar-transition-timing-function, ${csTransition.timingFunction})`,
}

export const style: CSSResult = css`
  :host {
    position: relative;
    display: block;
    max-width: 100%;
    overflow-x: clip;
  }

  csc-pdp-provider {
    display: contents;
  }

  cse-sticky-bar {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    transition-property: transform, opacity, visibility;
    transition-duration: ${cscPdpStickyBar.transitionDuration};
    transition-timing-function: ${cscPdpStickyBar.transitionTimingFunction};
  }

  :host(:not([visible])) cse-sticky-bar {
    position: absolute;
    inset-inline: 0;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }

  :host(:not([visible])) cse-sticky-bar[position="top"] {
    top: 0;
    transform: translateY(-100%);
  }

  :host(:not([visible])) cse-sticky-bar[position="bottom"] {
    bottom: 0;
    transform: translateY(100%);
  }

  @media (prefers-reduced-motion: reduce) {
    cse-sticky-bar {
      transition: none;
    }
  }

  .sticky-bar-content {
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    min-width: 0;
    justify-content: space-between;
  }

  .sticky-bar-content.mobile csc-product-preview {
    display: none;
  }

  .order-section {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .sticky-bar-content.mobile .order-section {
    width: 100%;
    flex-direction: column;
  }

  ::slotted([slot="price"]) {
    align-self: flex-start;
  }

  csc-order-form {
    align-self: flex-end;
  }
`
